module.exports = __webpack_public_path__ + "img/OverseaMember28.7e19ad0b.png";